import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

const Print = async (infoPrint) => {
    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    const getRows = (it) => {
        const { fio, birthday, sex, phoneNumber, address, job, complaints, diagnosis,
            diagforICD, currentDisease, anamnesis, inspExternal, bite
        } = infoPrint;
        let body = [
            [{ text: "ФИО", bold: true }, { text: fio }],
            [{ text: "Дата рождения", bold: true }, { text: birthday ? helper.date.toStr(it.birthday, "DD.MM.YYYY") : "" }],
            [{ text: "Пол", bold: true }, { text: infoPrint.sex === "MALE" ? "мужской" : sex === "FEMALE" ? "женский" : "" }],
            [{ text: "Адрес", bold: true }, { text: address ? address : "" }],
            [{ text: "Телефон", bold: true }, { text: phoneNumber ? helper.string.fromatPhone(phoneNumber) : "" }],
            [{ text: "Профессия", bold: true }, { text: job ? job : "" }],
            [{ text: "Жалобы", bold: true }, { text: complaints ? complaints : "" }],
            [{ text: "Диагноз", bold: true }, { text: diagnosis ? diagnosis : "" }],
            [{ text: "Диагноз по МКБ", bold: true }, { text: diagforICD ? diagforICD : "" }],
            [{ text: "Развитие настоящего заболевания", bold: true }, { text: currentDisease ? currentDisease : "" }],
            [{ text: "Анамнез жизни", bold: true }, { text: anamnesis ? anamnesis : "" }],
            [{ text: "Данные объективного исследования. Внешний осмотр", bold: true }, { text: inspExternal ? inspExternal : "" }],
            [{ text: "Прикус", bold: true }, { text: bite ? bite : "" }],
        ];
        const widths = [150, '*'];

        return { widths, body };
    };

    const formPage = (it) => {

        const page = [
            {
                style: 'header2',
                text: "Медицинская карта стоматологического больного "
            },
            {
                style: 'header3',
                text: ` ${infoPrint?.profileNumber} от ${helper.date.toStr(infoPrint?.inspection?.date, "DD.MM.YYYY")}`
            },
            {
                unbreakable: true,
                style: 'table',
                table: getRows(it)
            }
        ];

        return page;
    };

    const getDiag = (num, pos) => {
        let diag = infoPrint.dentalFormula[num - 1];
        let arr = [" \n ", " \n ", " \n "];

        if (diag && diag.includes(",")) {
            const diagArr = diag.split(",");
            arr[0] = diagArr[0];
            arr[1] = diagArr[1];
            if (diagArr.length > 2)
                arr[2] = diagArr[2];
        } else if (diag) {
            arr[0] = diag;
        }

        return arr[pos - 1];
    };

    let teethsArr = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28, 48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];
    teethsArr = [...teethsArr, 51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 81, 82, 83, 84, 85, 71, 72, 73, 74, 75];
    const mapTeeth = {};

    await Promise.all(teethsArr.map(async (i) => {
        mapTeeth[i] = {
            img: /*i > 50 ? await getImgTeeth(i, 0) : await getImgTeeth(i)*/"",
            diag1: getDiag(i, 1),
            diag2: getDiag(i, 2),
            diag3: getDiag(i, 3),
        };
    }));

    const teethsArr1 = [55, 54, 53, 52, 51, 18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28, 61, 62, 63, 64, 65];
    const teethsArr2 = [85, 84, 83, 82, 81, 48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38, 71, 72, 73, 74, 75];

    const bodyTeeths = [];

    bodyTeeths.push(teethsArr1.map(i => ({ text: mapTeeth[i].diag3, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag3.length > 3 ? 6 : 8, alignment: 'center' })));
    bodyTeeths.push(teethsArr1.map(i => ({ text: mapTeeth[i].diag2, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag2.length > 3 ? 6 : 8, alignment: 'center' })));
    bodyTeeths.push(teethsArr1.map(i => ({ text: mapTeeth[i].diag1, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag1.length > 3 ? 6 : 8, alignment: 'center' })));
    bodyTeeths.push(teethsArr1.map(i => ({ text: i, margin: [0, 10, 0, 10], fontSize: 10, fillColor: '#B6DCFA', bold: true, alignment: 'center' })));
    bodyTeeths.push(teethsArr2.map(i => ({ text: i, margin: [0, 10, 0, 10], fontSize: 10, fillColor: '#B6DCFA', bold: true, alignment: 'center' })));
    bodyTeeths.push(teethsArr2.map(i => ({ text: mapTeeth[i].diag1, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag1.length > 3 ? 6 : 8, alignment: 'center' })));
    bodyTeeths.push(teethsArr2.map(i => ({ text: mapTeeth[i].diag2, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag2.length > 3 ? 6 : 8, alignment: 'center' })));
    bodyTeeths.push(teethsArr2.map(i => ({ text: mapTeeth[i].diag3, margin: [0, 5, 0, 0], fontSize: mapTeeth[i].diag3.length > 3 ? 6 : 8, alignment: 'center' })));

    const documentDefinition = {
        pageSize: 'A4',
        content: [
            {
                style: 'header',
                table: {

                    widths: ['*', 200],
                    body: [
                        [
                            "Медицинская документация",
                            "КОД ФОРМЫ ПО ОКУД ____________"
                        ],
                        [
                            "Форма № 043/у",
                            "КОД УЧРЕЖДЕНИЯ ПО ОКПО ______"
                        ]
                    ],
                },
                layout: 'noBorders'
            },
            ...formPage(infoPrint),
            {
                unbreakable: true,
                style: 'table1',
                table: {
                    body: bodyTeeths,
                    widths: ['*', 18, 18, 18, 18, 18, 18, 18, 19, 19, 18, 19, 19, 19, 19, 19, 19, 18, 18, 18, 18, 18, 18, 18, 18, '*']
                },
                layout: {
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#000000'; }, // можно задать цвет
                    vLineColor: function () { return '#000000'; },
                    paddingLeft: function () { return 1; },
                    paddingRight: function () { return 0; },
                    paddingTop: function () { return 1; },
                    paddingBottom: function () { return 0; },
                },
            },
            {
                unbreakable: true,
                style: 'itogoTable2',
                table: {
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [
                        [{
                            text: [
                                "Осмотр полости рта. Состояние зубов. Условные обозначения: отсутствует — О, корень — R, кариес — С, пульпит ",
                                "— PI, периодонтит — Pt, пломба — П, пломба / кариес — П / С, подвижность — I, II - III(степень), коронка — К, ",
                                "искусственный зуб — И, формирователь — Ф, зубные отложения — з / о, клиновидный дефект — кл / д, рецессия — Р, ",
                                "глубокая фиссура — г / ф, герметик — г / р, скол — ск, дефект пломбы — д / п, вкладка — вк, пришеечный кариес — ",
                                "С / пр, вторичный кариес — С / втч, вывих зуба - Lux, трещина - Fr, временная коронка - Вр/ К"
                            ]
                        }]
                    ],
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                    hLineStyle: function (i, node) {
                        return { single: { length: 3, space: 2 } };
                    },
                    vLineStyle: function (i, node) {
                        return { single: { length: 3, space: 2 } };
                    },
                    paddingLeft: function (i, node) { return 5; },
                    paddingRight: function (i, node) { return 5; },
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                }
            },

        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
            },
            header3: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
                margin: [0, 0, 0, 10]
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                margin: [0, 0, 0, 15]
            },
            table1: {
                margin: [0, 0, 0, 15]
            },
            itogo: {
                fontSize: 10,
                margin: [0, 15, 0, 15]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
